import React, { useState, useEffect } from "react";
import roadlineImg from "../images/roadline.png";
import mobileRoadlineImg from "../images/mobile/mobile-road-map.png";
import config from '../config.json';
import Card from "../common/Card/Card";

function RoadMapSection() {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 1024;

  const styles = {
    0: {className: "bg-amber-300", styles: {}},
    1: {className: "bg-violet-200", styles: { marginTop: 250, paddingRight: 0 }},
    2: {className: "bg-violet-400", styles: { marginTop: -490, paddingLeft: 0, marginRight: -100  }},
    3: {className: "bg-amber-300", styles: { marginTop: 0, paddingLeft: 250 }},
    4: {className: "bg-violet-300", styles: { marginTop: -700, paddingRight: 150 } },
    5: {className: "bg-amber-200", styles: { marginTop: -150, paddingRight: 150 }},
  }
  return (
    <section id="roadmap" className="wrapper road-map">
      <h2 className="section-title text-center">
        Project roadmap
      </h2>
      <div
        className="flex items-center flex-wrap justify-center mb-20 relative"
        style={{ height: "100%", minHeight: 1692, marginTop: -150 }}
      >
        <img
          className="absolute"
          src={isMobile ? mobileRoadlineImg : roadlineImg}
          alt="orange-bg"
          style={{ top: 240, zIndex: 0, height: "100%" }}
        />
        {config.roadmap.map((item, index) => (
            <div
             key={index}
             className="w-full md:w-1/2  mb-10 relative flex justify-center"
             style={isMobile ? {} :styles[index].styles}
           >
             <Card
               className={styles[index].className}
               title={item.date}
               description={item.text}
             />
           </div>
        ))}
      </div>
    </section>
  );
}

export default RoadMapSection;
